'use client';

import { forwardRef } from 'react';

import { TextArea } from '@highlight-cp/core-ui';
import type { TextAreaProps } from '@highlight-cp/core-ui';

export type MonospaceTextAreaProps = TextAreaProps;

/**
 * ### MonospaceTextArea
 *
 * @description
 * Textarea whose input renders in the theme's monospace font.
 * Use for code, JSON, configuration snippets, IDs, or content that benefits from
 * aligned columns. Same restricted API as the core-ui `TextArea`.
 *
 * `data-monospace` is Mantine's own input hook — the same one `JsonInput` uses. The font itself is
 * pinned by the theme's `Textarea` entry, since the app theme's `fontFamilyMonospace` is Inter.
 *
 * @example
 * <MonospaceTextArea label="Request body" placeholder="{}" />
 *
 * @param props - {@link MonospaceTextAreaProps}
 * @returns React component
 */
export const MonospaceTextArea = forwardRef<HTMLTextAreaElement, MonospaceTextAreaProps>(
  (props, ref) => <TextArea ref={ref} data-monospace {...props} />,
);

MonospaceTextArea.displayName = 'MonospaceTextArea';
